export const DELIVERY_INFO_SELECTORS: Record<string, string> = {
    'standard': 'nextDay',
    'sameday': 'sameDay',
    'rapid': 'rapid',
    'extended': 'prebook'
}

export const DeliveryTypes ={
  SAMEDAY: 'sameday',
  RAPID: 'rapid',
  STANDARD: 'standard',
  PREBOOK: 'extended'
}

export interface DeliveryType {
    deliveryType: string
    title: string
    shortTitle: string
    available: boolean
    lowestCost: number | null
    unavailableMessage: string | null
    deliveryTypeSubtext: string
    features: string[]
    loading: boolean

}
export interface AvailableDeliveryMethod extends DeliveryType {
    type?: string
    sortOrder?: number
    backgroundImage?: string
    icon?: string | null
    ctaText?: string | null
    theme?: 'light' | 'dark'
}

export interface DeliveryBoxProps extends AvailableDeliveryMethod {
    minSpend?: number | null
    contentClassName?: string
}